/** @jsxImportSource @emotion/react */

import { TextStyled } from '@nike/nike-design-system-components';
import { nike } from '@nike/nike-design-tokens';
import { useSelector } from 'react-redux';

import StartInvitationButton from './invitations/StartInvitationButton';

import { TranslatedCopy } from '../intl/TranslatedCopy';
import Truncator from '../components/Truncator';
import { invitationsSelectors } from './invitations/reducer';
import { usersSelectors } from './users/reducer';
import { getUserAccount } from '../user/selectors';

const UsersHeader = () => {
  const activeUsersCount = useSelector(usersSelectors.activeUsersCount);
  const deactivatedUsersCount = useSelector(usersSelectors.deactivatedUsersCount);
  const expiredInvitationsCount = useSelector(invitationsSelectors.expiredInvitationsCount);
  const pendingInvitationsCount = useSelector(invitationsSelectors.pendingInvitationsCount);
  const selectedAccount = useSelector(getUserAccount);

  return (
    <div
      css={{
        background: nike.podiumCdsColorBgPrimary,
        height: '148px',
        padding: '24px',
        width: '100%'
      }}
    >
      <div
        css={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          '@media (min-width: 769px)': {
            justifyContent: 'flex-start'
          }
        }}
      >
        <TextStyled appearance='title3'>
          <Truncator value={`${selectedAccount?.number} ${selectedAccount?.name}`} />
        </TextStyled>
      </div>
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          height: '48px',
          marginTop: '24px',
          width: '100%',
          '@media (min-width: 769px)': {
            flexDirection: 'row'
          }
        }}
      >
        <div
          css={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            '@media (min-width: 769px)': {
              justifyContent: 'flex-start',
              width: '50%'
            }
          }}
        >
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center',
              '@media (min-width: 769px)': {
                textAlign: 'left',
                paddingRight: '20px'
              }
            }}
          >
            <TextStyled appearance='body2' color={nike.podiumCdsColorGrey500}>
              <TranslatedCopy id='userManagement.status.active' />
            </TextStyled>
            <TextStyled appearance='body1' bold>
              {activeUsersCount}
            </TextStyled>
          </div>
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center',
              '@media (min-width: 769px)': {
                textAlign: 'left',
                paddingRight: '20px'
              }
            }}
          >
            <TextStyled appearance='body2' color={nike.podiumCdsColorGrey500}>
              <TranslatedCopy id='userManagement.status.deactivated' />
            </TextStyled>
            <TextStyled appearance='body1' bold>
              {deactivatedUsersCount}
            </TextStyled>
          </div>
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center',
              '@media (min-width: 769px)': {
                textAlign: 'left',
                paddingRight: '20px'
              }
            }}
          >
            <TextStyled appearance='body2' color={nike.podiumCdsColorGrey500}>
              <TranslatedCopy id='userManagement.status.expired' />
            </TextStyled>
            <TextStyled appearance='body1' bold>
              {expiredInvitationsCount}
            </TextStyled>
          </div>
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              textAlign: 'center',
              '@media (min-width: 769px)': {
                textAlign: 'left'
              }
            }}
          >
            <TextStyled appearance='body2' color={nike.podiumCdsColorGrey500}>
              <TranslatedCopy id='userManagement.status.sent' />
            </TextStyled>
            <TextStyled appearance='body1' bold>
              {pendingInvitationsCount}
            </TextStyled>
          </div>
        </div>
        <div
          css={{
            display: 'none',
            '@media (min-width: 769px)': {
              display: 'flex',
              justifyContent: 'flex-end',
              width: '50%'
            }
          }}
        >
          <StartInvitationButton />
        </div>
      </div>
    </div>
  );
};

export default UsersHeader;
